package com.macrofocus.trenddisplay.timeseriesplot

import com.macrofocus.trenddisplay.timeseriesplot.TimeSeriesPlotConfiguration.MarkerType
import org.mkui.geom.GeneralPath
import org.mkui.geom.Path2D
import org.mkui.geom.Rectangle2D
import org.mkui.geom.Shape
import org.mkui.graphics.IGraphics
import org.mkui.palette.Palette
import org.mkui.palette.PaletteFactory
import org.mkui.transform.TwoDScreenTransform
import org.molap.series.TimeSeries
import kotlin.math.max

class HeatmapTimeSeriesRenderer(paletteFactory: PaletteFactory) : TimeSeriesPlotRenderer {
    private val normalColormap: Palette =
        paletteFactory.get("lingrey")!!.getPalette() // InverseColormapModel(new LingreyColormapModel(50, 206))
    private val probedColormap: Palette =
        paletteFactory.get("Blues")!!.getPalette() // InverseColormapModel(new BlueColormapModel());
    private val selectedColormap: Palette =
        paletteFactory.get("linred")!!.getPalette() // InverseColormapModel(new LinredColormapModel(50, 206))

    override fun getShape(
        timeSeries: TimeSeries<Int, *>?,
        screenTransform: TwoDScreenTransform,
        mode: TimeSeries.TimeMode,
        configuration: TimeSeriesPlotConfiguration
    ): Pair<Path2D.Double, Path2D.Double> {
        val markerPath: GeneralPath = GeneralPath()
        val linePath: GeneralPath = GeneralPath()

        val isNumerical = true
        if (isNumerical) {
            if (timeSeries != null) {
                var previous: RangePoint? = null

                for (i in timeSeries.keys()!!) {
                    val x: Int = screenTransform.xWorldToScreen(timeSeries.getTime(mode, i).toDouble())
                    val yValue: Any? = timeSeries.get(i)
                    if (yValue != null) {
                        val y: Int = screenTransform.yWorldToScreen((yValue as Number).toDouble())

                        if (previous != null) {
                            if (x != previous.x) {
                                if (previous.yMin != previous.yMax) {
                                    if (configuration.getLineType() != TimeSeriesPlotConfiguration.LineType.None) {
                                        linePath.lineTo(previous.x.toDouble(), previous.yMin.toDouble())
                                        linePath.lineTo(previous.x.toDouble(), previous.yMax.toDouble())
                                        linePath.lineTo(previous.x.toDouble(), previous.y.toDouble())
                                    }
                                }
                                if (configuration.getLineType() != TimeSeriesPlotConfiguration.LineType.None) {
                                    if (configuration.getLineType() == TimeSeriesPlotConfiguration.LineType.Step) {
                                        linePath.lineTo(x.toDouble(), previous.y.toDouble())
                                    }
                                    linePath.lineTo(x.toDouble(), y.toDouble())
                                }
                            }
                            previous.setValue(x, y.toDouble())
                        } else {
                            previous = RangePoint()
                            previous!!.setValue(x, y.toDouble())
                            linePath.moveTo(x.toDouble(), y.toDouble())
                            linePath.lineTo(x.toDouble(), y.toDouble())
                        }

                        if (configuration.getMarkerType() != MarkerType.None) {
                            val size = configuration.getMarkerSize().toDouble()
                            val halfSize = size / 2.0
                            val shape: Shape = Rectangle2D.Double(x - halfSize, y - halfSize, size, size)
                            markerPath.append(shape.getPathIterator(), false)
                        }
                    } else {
                        previous = null
                    }
                }
            }
        } else {
//            final TimeSeriesVariable timeSeriesVariable = (TimeSeriesVariable) variable;
//            final TimeSeries timeSeries = (TimeSeries) timeSeriesVariable.getValue(dataset, plot.getSubject());

            if (timeSeries != null) {
                if (configuration.getMarkerType() != MarkerType.None || configuration.getDisplayValue()) {
//                    val textY: Int = g2.getFontMetrics()!!.getAscent()
                    for (i in 0..<timeSeries.size()) {
//                        final int x = plot.worldToScreenX(timeSeries.getTime(i));
                        val value: Any? = timeSeries.get(i)

                        if (value != null) {
                            when (configuration.getMarkerType()) {
                                MarkerType.VerticalLine -> {}
                                MarkerType.Point -> {
                                    val size = configuration.getMarkerSize()
                                    val halfSize = size / 2.0f
                                }
                                MarkerType.None -> {}
                            }
                            if (configuration.getDisplayValue()) {
                                when (configuration.getMarkerType()) {
                                    MarkerType.None, MarkerType.VerticalLine -> {}
                                    MarkerType.Point -> {}
                                }
                            }
                        }
                    }
                }
            }
        }

        return Pair(markerPath, linePath)
    }

    override fun draw(
        timeSeries: TimeSeries<Int,*>?,
        screenTransform: TwoDScreenTransform,
        g2: IGraphics,
        mode: TimeSeries.TimeMode,
        configuration: TimeSeriesPlotConfiguration,
        probed: Boolean,
        selected: Boolean
    ) {
//        final Color oldColour = g2.getColor();
//        final Stroke oldStroke = g2.getStroke();
//        final Font oldFont = g2.getFont();

        g2.setColor(configuration.getLineColor())

        val isNumerical = true
        if (isNumerical) {
            val colormap: Palette = if (selected) {
                selectedColormap
            } else if (probed) {
                probedColormap
            } else {
                normalColormap
            }

            if (timeSeries != null) {
                var previous: HeatmapTimeSeriesRenderer.RangePoint? = null

                for (i in timeSeries.keys()!!) {
                    val x: Int = screenTransform.xWorldToScreen(timeSeries.getTime(mode, i).toDouble())
                    val yValue: Any? = timeSeries.get(i)
                    if (yValue != null) {
                        val y: Int = screenTransform.yWorldToScreen((yValue as Number).toDouble())

                        if (previous != null) {
                            if (x != previous.x) {
                                if (configuration.getLineType() != com.macrofocus.trenddisplay.timeseriesplot.TimeSeriesPlotConfiguration.LineType.None) {
                                    var entry =
                                        ((colormap.colorCount - 1) * max(y.toDouble(), previous.yMax)).toInt()
                                    if (entry < 0) {
                                        entry = 0
                                    }
                                    if (entry >= colormap.colorCount) {
                                        entry = colormap.colorCount - 1
                                    }
                                    g2.setColor(colormap.getColorAt(entry))
                                    g2.fillRectangle(previous.x, 0, x - previous.x, screenTransform.screenHeight)
                                }
                                //                            if(configuration.getLineType() != TimeSeriesPlotConfiguration.LineType.None) {
                                //                                int entry = (int)((colormap.getColorCount() - 1) * previous.yMax);
                                //                                g2.setColor(colormap.getColor(entry));
                                //                                g2.drawLine(x, 0, x, plot.getHeight());
                                //                            }
                            }
                            previous.setValue(x, y.toDouble())
                        } else {
                            previous = RangePoint()
                            previous!!.setValue(x, y.toDouble())
                            val entry = ((colormap.colorCount - 1) * y).toInt()
                            g2.setColor(colormap.getColorAt(entry))
                            g2.drawLine(x, 0, x, screenTransform.screenHeight)
                        }
                        if (configuration.getMarkerType() != MarkerType.None) {
                            val size = configuration.getMarkerSize()
                            val halfSize = size / 2.0f
                            g2.drawLine(x, 0, x, screenTransform.screenHeight)
                        }
                    }
                }
            }
        } else {
            if (timeSeries != null) {
                g2.setColor(configuration.getMarkerColor())

                if (configuration.getMarkerType() == MarkerType.VerticalLine) {
//                    g2.setStroke(new BasicStroke(configuration.getMarkerSize()));
                }
                if (configuration.getDisplayValue()) {
//                    final Font font = g2.getFont().deriveFont(8.0f * configuration.getMarkerSize());
//                    g2.setFont(font);
                }

                if (configuration.getMarkerType() != MarkerType.None) {
                    for (i in timeSeries.keys()!!) {
                        val x: Int = screenTransform.xWorldToScreen(timeSeries.getAbsoluteTime(i).toDouble())
                        val value: Any? = timeSeries.get(i)

                        if (value != null) {
                            when (configuration.getMarkerType()) {
                                MarkerType.VerticalLine -> {}
                                MarkerType.Point -> {
                                    val size = configuration.getMarkerSize()
                                    val halfSize = size / 2.0f
                                }
                                MarkerType.None -> {}
                            }
                        }
                    }
                }
            }
        }

        //        g2.setColor(oldColour);
//        g2.setStroke(oldStroke);
//        g2.setFont(oldFont);
    }

    private inner class RangePoint {
        var x: Int = 0
        var y: Double = 0.0
        var yMin: Double = 0.0
        var yMax: Double = 0.0

        fun setValue(x: Int, y: Double) {
            if (this.x == x) {
                if (y < yMin) {
                    yMin = y
                }
                if (y > yMax) {
                    yMax = y
                }
                this.y = y
            } else {
                this.x = x
                this.y = y
                this.yMin = y
                this.yMax = y
            }
        }
    }
}
